<template >
    <v-flex class="userLogin">
        <v-toolbar flat class="mx-auto mb-4">
            <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
        </v-toolbar>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-text-field v-model="vusername" label="Username" ></v-text-field>
            <v-text-field ref="lpassword" v-model="vpassword" label="Password" :type="'password'" hint="Password must be minimum of 8 characters, and must include an uppercase letter, lowercase letter, number, and special character." ></v-text-field>
            <v-btn round color="primary" dark  v-on:click.native="logUserIn(vusername, vpassword)">Login</v-btn>
            <v-btn round color="primary" dark  v-if="true" v-on:click.native="forgot(vusername)">Forgot Password</v-btn>
            <v-btn round color="primary" dark  v-if="true" @click.stop="createDialog = true">Create Account</v-btn>
            <v-btn round color="primary" dark  v-if="true"  v-on:click.native="logUserOut()">Logout</v-btn>
          </div>
            <v-dialog
                v-model="loginDialog"
                fullscreen
                :overlay="false"
                scrollable
            >
              <v-parallax class="bg-img " height="100%"  scrollable >
                <v-card  height="100%" class="home-login-wrapper" scrollable>
                <v-card-text class="splash-flex" scrollable>
                    <v-flex xs10 mx-auto class="splash-flex" scrollable>
                        <div class="text-xs-center splash-flex" xs10 style="max-width: 500px; flex-grow:1;" scrollable>
                            <div class="card--logo-splash"><img src="/images/VT-Lockup-White.png" :title='appTitle' scrollable></div>
                            <div v-if="false" class="display-2  splash-logo-txt " >{{appTitle}}</div>
                            <div class="splash-inputs">

                            <v-form @keydown.native.enter="submit(vusername, vpassword)">
                                <v-text-field class="my-1" name="vusername" solo hide-details color="black" v-model="vusername" label="Username" :rules="itemRules"
                                data-vv-name="vusername"
                                autocomplete="name"
                                v-validate="'required'">
                                </v-text-field>

                                <v-text-field solo hide-details color="black" v-model="vpassword" label="Password" :type="'password'" :rules="itemRules" hint="Forgot"
                                data-vv-name="vpassword" name="vpassword"
                                autocomplete="password"
                                v-validate="'required'">
                                </v-text-field>
                                <v-alert class="mb-4" type="success" v-model="forgotSuccess" dismissible>{{forgotSuccessMessage}}</v-alert>
                                <v-alert class="caption my-1 py-2 px-2 text-xs-left" color="error" v-model="forgotDialog" type="error" icon="" dismissible >{{errorMessage}}
                                  <v-btn v-if="false" color="white" @click="forgotDialog = !forgotDialog">Close</v-btn>
                                </v-alert>
                                <v-btn  block color="blue-grey lighten-5" v-if="false" v-on:click.native="forgot(vusername)" @click.stop="forgotDialogBox = true">Reset Password</v-btn>
                                <v-btn  block color="blue-grey lighten-5" v-if="displayForgot"  v-on:click.native="forgotDialogBox = true">Reset Password</v-btn>

                                <v-progress-circular class="my-1" indeterminate color="white" v-if="loggingIn"></v-progress-circular>

                                <v-btn  block color="primary" dark class="mt-4 mb-2"  @click="submit(vusername, vpassword)" >Login</v-btn>

                                <v-btn  block color="blue-grey lighten-5" v-if="true" @click.stop="createDialog = true">Create Account</v-btn>
                                <v-btn v-if="false" depressed block color="primary" mx-auto class=" mt-5 splash-login text-xs-center" dark  @click.native="loginDialog = false">Login</v-btn>

                                <div class="mt-1 caption disclaimer text-xs-left">
                                  *This application offers recommendations for best practices with regard to voice use.
                                  The guidelines and information are for educational purposes and not intended to make medical diagnoses.
                                </div>
                            </v-form>

                            <VideoEmbed :src="video_src" />
                            
                            </div>
                        </div>
                    </v-flex>
                </v-card-text>
                </v-card>
                </v-parallax>
            </v-dialog>
            <v-dialog
              v-model="createDialog"
              fullscreen
              :overlay="false"
              scrollable
            >
              <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-btn icon @click.native="createDialog = false" dark>
                    <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Create {{appTitle}} Account</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs10 mx-auto>
                        <div class="text-xs-center">

                            <div class="headline mt-4">Create a {{appTitle}} Account</div>
                            <div class="text-xs-left mt-4 mb-2">All fields are required.</div>
                            <v-text-field
                                v-model="vemail"
                                label="Email" :rules="itemRules"
                                data-vv-name="vemail"
                                v-validate="'required'" >
                            </v-text-field>
                            <v-text-field
                                v-model="vusername"
                                label="Username" :rules="itemRules"
                                data-vv-name="vusername"
                                v-validate="'required'"
                                autocomplete="false" ></v-text-field>

                            <v-text-field class="mb-4 text-xs-left"
                                v-model="vpassword"
                                label="Password"
                                :type="'password'" :rules="itemRules"
                                data-vv-name="vpassword"
                                hint="Password must be a minimum of 8 characters long, and contain an uppercase character (A-Z), a lowercase character (a-z), and a digit (0-9)."
                                persistent-hint
                                v-validate="'required'"
                                autocomplete="false"
                            ></v-text-field>
                            <v-checkbox
                                    label="Terms of Service"
                                    v-model="termsOfService"
                                    required
                                    hint="Do you agree to the Terms of Service?"
                                    persistent-hint
                                    :rules="itemRules"
                                    :error-messages="errors.collect('termsOfService')"
                                    data-vv-name="termsOfService"
                                    v-validate="'required'"
                                    color="primary"
                            ></v-checkbox>
                            <div class="text-xs-left mt-2 mb-4">
                                    <a @click.stop="termsDialog = true; createDialog = false;">{{appTitle}} Terms of Service</a>
                            </div>
                            <v-alert class="mb-4" type="error"  icon="warning" v-model="createError"  dismissible>{{createErrorMessage}}</v-alert>
                            <v-alert class="mb-4" type="success" v-model="createSuccess" :show="createSuccess" dismissible>{{createSuccessMessage}}</v-alert>
                            <v-btn flat color="primary" dark  @click.native="createDialog = false" >Back to Login</v-btn>
                            <v-btn round color="primary" dark  v-on:click.native="createAccount(vusername, vemail, vpassword)">Create Account</v-btn>

                        </div>
                    </v-flex>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="forgotDialogBox"
              fullscreen
              :overlay="false"
              scrollable
            >
              <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-btn icon @click.native="forgotDialogBox  = false" dark>
                    <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{appTitle}} Password Recovery</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs10 mx-auto>
                        <div class="text-xs-center">

                            <div class="headline mt-4">Reset Your {{appTitle}} Password</div>
                            <div class="text-xs-left mt-4 mb-2">All fields are required.</div>

                            <v-text-field v-if="!getResetValues"
                                v-model="vusername"
                                label="Username" :rules="itemRules"
                                data-vv-name="vusername"
                                v-validate="'required'"></v-text-field>
                            <v-text-field class="mb-4 text-xs-left" v-if="getResetValues"
                                v-model="vresetcode"
                                label="Verification Code"
                                data-vv-name="vresetcode"
                                hint="A verfication code has been sent to your registered email account. Please input the verification code."
                                persistent-hint
                                v-validate="'required'"></v-text-field>
                            <v-text-field class="mb-4 text-xs-left" v-if="getResetValues"
                                v-model="vpassword"
                                label="New Password"
                                :type="'password'" :rules="itemRules"
                                data-vv-name="vpassword"
                                hint="Password must be a minimum of 8 characters long, contain an uppercase character (A-Z), a lowercase character (a-z), and a digit (0-9)."
                                persistent-hint
                                v-validate="'required'"></v-text-field>
                            <v-alert class="mb-4" type="error"  icon="warning" v-model="forgotError" dismissible>{{forgotErrorMessage}}</v-alert>
                            <v-btn flat color="primary" dark  @click.native="forgotDialogBox = false" >Back to Login</v-btn>
                            <v-btn round color="primary" dark  v-on:click.native="forgot(vusername)" v-if="!toggleForgotSubmit">Request Password Reset</v-btn>
                            <v-btn round color="primary" dark  v-on:click.native="forgotConfirm(vresetcode, vpassword)" v-if="toggleForgotSubmit">Submit Password Reset</v-btn>

                        </div>
                    </v-flex>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              scrollable
              v-model="termsDialog"
              fullscreen
              :overlay="false"
            >
                <v-card>
                        <v-toolbar dark color="primary">
                        <v-btn icon dark @click.native="termsDialog = false; createDialog = true;">
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-toolbar-title>Back to Create Account</v-toolbar-title>
                        </v-toolbar>
                        <terms></terms>
                </v-card>
            </v-dialog>

        </v-flex>
    </v-flex>
</template>





<style >
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus
input:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus,
.card.home-login-wrapper input:-webkit-autofill, .card.home-login-wrapper textarea:-webkit-autofill, .card.home-login-wrapper select:-webkit-autofill {
    background-color: rgb(255, 255, 255) !important;
    background-image: none !important;
    color: rgb(0, 0, 0) !important;
    border: 1px solid #fff;
    -webkit-text-fill-color: #000;
    transition: background-color 5000s ease-in-out 0s;
}
.card.home-login-wrapper{
    box-shadow: none;
}
.home-login-wrapper {
  background-color: transparent !important;
  box-shadow: none;
}
.userLogin{display: none;}

.bg-img{
  width: 100%;
  background-color: #1e6b96;
}
.parallax__content{overflow: auto;}
.parallax__image-container{
  transform: scale(1.1);
  opacity: .9;
  background: #ccc url(/images/VT-Landing-4.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

@media all and (max-width: 1200px){
  .parallax__image-container{
    filter: blur(2px);
  }
}

@media all and (max-width:  768px){
  .parallax__image-container{
    filter: blur(0px);
  }
}

.splash-flex{
    display: flex;
    justify-content: unset;
    height: 100% !important;
    flex-flow: column;
    flex-grow: 1 !important;
}

.input-group--solo{
  opacity: .7;
}
.input-group--focused{
  opacity: 1;
}

.card--logo-splash, .card--logo-splash img{
    max-width: 400px;
    width: 100%;
    min-width: 200px;
}
.card--logo-splash{
    margin-top: 5%;
    margin: 5% auto auto auto;
}
.splash-logo-txt{
    color: #1a75d2;
    font-weight: 500;
   display: none;
}
.splash-inputs{
    margin-top: auto;
    margin-bottom: 10%;
}



/* .card--logo-splash .input-group.input-group--text-field.primary--text {} */
.disclaimer{color: #fff;}


</style>

<script>

import LoginService from './LoginService.js'
import AppConst from './AppConst.js'
import CreateUser from './CreateUser.vue';
import CreateUserMutation from './mutations/CreateUserMutation'
import ListUsersQuery from './queries/ListUsersQuery';
import UserSettings from './UserSettings'
import SingleUserQuery from './queries/SingleUserQuery';
import TermsOfService from './TermsOfService.vue';
import VideoEmbed from "@/components/VideoEmbed";

var startSessionValid=false;


var appTitleLocal = AppConst.appTitle;

export default {
  $_veeValidate: {
      validator: 'new'
},
  data () {
    return {
      vusername: localStorage.username || '',
      vpassword: '',
      vemail: '',
      vvoiceDescriptive: '',
      vage: '',
      vgenderType: '',
      vvoiceType: '',
      vgoals: '',
      vsingerType: '',
      msg: 'Login',
      session: startSessionValid,
      createDialog: false,
      termsDialog: false,
      loginDialog: !startSessionValid,
      forgotDialog: false,
      forgotDialogBox: false,
      appTitle: appTitleLocal,
      VoiceTypeDefaults: AppConst.registerVoiceTypeDefaults,
      AgeDefaults: AppConst.registerAgeDefaults,
      GenderDefaults: AppConst.registerGenderDefaults,
      SingerTypeDefaults: AppConst.registerSingerTypeDefaults,
      GoalsDefaults: AppConst.registerGoalsDefaults,
      VoiceDescriptivesDefaults: AppConst.registerVoiceDescriptivesDefaults,
      CreateUserMutation: CreateUserMutation,
      ListUsersQuery: ListUsersQuery,
      UserSettings: UserSettings,
      displayForgot: false,
      getResetValues: false,
      itemRules: [
        v => !!v || 'All fields are required.',
      ],
      createErrorMessage:'',
      createError: false,
      createSuccessMessage:'',
      createSuccess: false,
      errorMessage: '',
      loggingIn: false,
      vresetcode: '',
      toggleForgotSubmit: false,
      forgotError: false,
      forgotSuccess: false,
      forgotErrorMessage:'',
      forgotSuccessMessage:'',
      termsOfService: 'true',
      video_src: 'https://www.youtube.com/embed/IvonQCRRXwQ?rel=0'
    }
  },
  components: {
                'create-user': CreateUser,
                'terms': TermsOfService,
                VideoEmbed

  },
  mounted(that=this){
        //check cognito session
        LoginService.getSession(that, function(data){
            startSessionValid=data;

            if(startSessionValid==false){

                that.checkRefresh(that, function(data){
                    that.startSessionValid=data;
                    if(that.startSessionValid==true){
                            that.loggingIn=false;
                            localStorage.checkUserRegistration=true;
                    }
                });
            }
            else{
                //user has session
            }

        });

        //hack for autofill
        //var elem = this.$refs.lpassword; // Element to fire on
        //var prevented = elem.dispatchEvent(new Event("click")); // Fire event
  },
  methods: {
        submit (vusername, vpassword) {

            this.loggingIn=true;
            this.logUserIn(vusername.trim(), vpassword.trim());
        },
        checkRefresh: function(that, callback){
            LoginService.getRefreshToken(that, function(err, data){
                if(err){
                    return
                }
                else{
                    that.startSessionValid=data;
                    callback(startSessionValid);
                }
            });
        },
        forgot: function(vusername){
            var that=this;
            LoginService.forgotLogin(that, vusername, function(err){
                        if(err!=null){
                            console.log(err);
                            that.forgotError= true;
                            that.forgotDialog = true;
                            that.forgotErrorMessage="Error: please verify that you are using the correct username.";

                        }
                        else {
                            that.forgotError= false;
                            that.forgotDialog = false;
                            that.forgotErrorMessage='';
                            that.getResetValues=!that.getResetValues;
                            that.toggleForgotSubmit=!that.toggleForgotSubmit;
                        }
                });
        },
        forgotConfirm: function(verificationCode, newPassword){
            var that=this;
            LoginService.confirmForgotPassword(that, verificationCode, newPassword, function(err, data){
                        if(err!=null){
                            that.forgotError= true;
                            that.forgotDialog = true;
                            that.forgotErrorMessage="Verfication code and password are required.";
                        }
                        if(data!=null) {
                            that.forgotDialog = false;
                            that.forgotDialogBox = false;
                            that.forgotSuccess = true;
                            that.displayForgot = false;
                            that.forgotError= false;
                            that.forgotErrorMessage='';
                            that.forgotSuccessMessage="Password successfully reset";
                        }
            });
        },
        logUserIn: function(vusername, vpassword){
                vusername=vusername.trim();
                vpassword=vpassword.trim();
                var that=this;
                LoginService.logUserIn(vusername, vpassword, function(err, data){
                        if(err!=null){
                            console.log(err);
                            that.errorMessage="Login Error: Please confirm that your username and password are correct.";
                            that.forgotDialog = true;
                            that.loggingIn=false;
                            that.displayForgot=true;
                        }

                        if(data!=null) {
                            //check for userRegistration

                            that.loggingIn=false;
                            console.log('to registration');
                            localStorage.checkUserRegistration=true;
                            that.$router.push('/user');
                            that.$router.go();

                            that.singleUser(that, localStorage.subID, function(data){
                                var me=data.data.singleUser;
                                if(!(me==null || me==undefined)){
                                    if(localStorage.checkUserRegistration=='true'){
                                        console.log('cancel registration nav');
                                        localStorage.checkUserRegistration=false;
                                        that.$router.push('home');
                                        that.$router.go();
                                    }
                                    else{
                                        console.log('to registration');
                                        localStorage.checkUserRegistration=true;
                                        that.$router.push('user');
                                        that.$router.go();
                                    }
                                }
                                else{
                                    console.log('to registration');
                                    localStorage.checkUserRegistration=true;
                                    that.$router.push('user');
                                    that.$router.go();
                                }
                            });

                        }
                });
                that.displayForgot=true;

        },
        singleUser: function(that, data, callback){
            that.$apollo
            that.$apollo.query({ variables: {

                            id: localStorage.subID,

                    },query: SingleUserQuery })
            .then(function logData(data) {
                callback(data);
            }).catch(console.error);
        },
        logUserOut: function(){
            LoginService.logUserOut();


        },
        createAccount: function(vusername, vemail, vpassword){

            if(this.termsOfService===false){
                this.createErrorMessage = 'You must agree to the Terms of Service.';
                this.createError=true;
                this.createSuccess=false;
                throw new TypeError(this.createErrorMessage );
            }

            if (vusername=== '' || vemail === '' || vpassword === '') {
                this.createErrorMessage = 'Please enter a username, email and password to register for an account.';
                this.createError=true;
                this.createSuccess=false;
                throw new TypeError(this.createErrorMessage );
            }
            /* store these locally */
            localStorage.username=vusername;
            localStorage.email=vemail;
            var that=this;
            LoginService.registerUser(vusername.trim(), vemail.trim(), vpassword.trim(), (err, data)=>{
                if(err){
                    that.createError=true;
                    that.createErrorMessage="Please enter a valid email, username, and password."
                    if(err.code=="UsernameExistsException"){
                        that.createErrorMessage=err.message;
                    }
                    console.log(data);
                    console.log(err);
                }
                else{
                    that.createSuccess=true;
                    that.createError=false;
                    that.createSuccessMessage=data;
                }

            } );
        }
  }

}


</script>



// WEBPACK FOOTER //
// src/components/Login.vue